import { useEffect } from 'react';
import { getParams } from '../util';

const FullStoryInitialization = () => {
  useEffect(() => {
    if (!window.FS) return undefined;

    const uid = getParams('uid');
    if (!uid) return undefined;

    window.FS('setIdentity', {
      uid,
      properties: {
        application_id: uid,
        tenant: 'aaaulp',
        environment: process.env.REACT_APP_NODE_ENV || 'local',
        application: 'acquire-app-web-v1',
      },
    });

    return () => {
      window.FS && window.FS('setIdentity', { anonymous: true });
    };
  }, []);

  return null;
};

export default FullStoryInitialization;
